import type { TextUIPart, UIMessage } from 'ai'

export type LlmChatUserMessageBubbleProps = {
  message: UIMessage
}

export function LlmChatUserMessageBubble({ message }: LlmChatUserMessageBubbleProps) {
  const textParts = message.parts.filter(
    (part): part is TextUIPart => part.type === 'text'
  )
  const contentText = textParts.map((part) => part.text).join('')

  return (
    <div className='flex w-full justify-end py-3'>
      <div className='ml-auto w-full max-w-[min(100%,42rem)]'>
        <div className='rounded-lg bg-muted/80 px-3 py-2 text-[13px] leading-6 text-foreground dark:bg-muted/50'>
          <div className='wrap-break-word whitespace-pre-wrap'>{contentText}</div>
        </div>
      </div>
    </div>
  )
}
